<template>
  <el-dialog
    :visible.sync="dialogTableVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="2%"
    @close="handleClose"
  >
    <span slot="title" class="dialog-title">套餐购买/续费</span>
    <div class="pan-thumb-box" v-loading="loading">
      <div class="pan-thumb-info">
        <div class="pan-thumb-info-text">
          <span style="color: #ff4646">*</span>
          <span> 机构选择：</span>
          <el-radio
            v-model="radio"
            :label="item.value"
            v-for="item in radioButton"
            :key="item.value"
            @change="handleChange(item)"
            >{{ item.label }}</el-radio
          >
        </div>
        <div
          class="pan-thumb-info-text"
          v-if="radio === '00000000-0000-0000-0000-000000000000'"
        >
          <span style="color: #ff4646">*</span>
          <span> 机构选择：</span>
          <el-select
            v-model="value"
            filterable
            placeholder="请选择"
            style="width: 50%"
            @change="handleEnterpriseChange"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="pan-thumb-info-btn-box">
          <div :class="['pan-thumb-info-btn', { isText: payInfo.hasDiscount }]">
            <div class="pan-thumb-info-btn-top">
              <span class="pan-thumb-info-btn-pay">{{ payInfo.priceStr }}</span>
              <span style="margin-top: 10px">/{{ payInfo.unit }}</span>
            </div>
            <div class="pan-thumb-info-btn-desc" v-if="payInfo.hasDiscount">
              <span style="font-size: 15px">{{
                payInfo.beforeDiscountPrice
              }}</span>
              <span style="font-size: 10px">/{{ payInfo.unit }}</span>
              <div class="pan-thumb-info-btn-desc-line"></div>
            </div>
            <img
              class="pan-thumb-info-btn-img"
              src="@/assets/purchase/pay-icon.png"
            />
          </div>
          <div class="pan-thumb-info-btn-text" v-if="payInfo.hasDiscount">
            {{ payInfo.discountDescription }}
          </div>
        </div>
        <div class="pan-thumb-info-text">
          <span>套餐内容：{{ payInfo.projectName }}</span>
        </div>
        <div class="pan-thumb-info-text">
          <span>有效期至：{{ payInfo.validEnd }}</span>
        </div>
        <div class="pan-thumb-info-text">
          <span
            >应付金额：<span style="color: #fd5f39; font-size: 16px">{{
              payInfo.price
            }}</span
            >元</span
          >
        </div>
        <div class="pan-thumb-info-button" v-if="radioButton.length === 2">
          <el-button type="primary" @click="handleCreateOrder">
            <i class="el-icon-refresh"></i>
            订单
          </el-button>
        </div>
      </div>
      <div class="pan-thumb-pay" v-if="isOrder">
        <div class="pan-thumb-pay-text-box">
          <div class="pan-thumb-pay-text">支付方式：</div>
          <div class="pan-thumb-pay-text-btn">
            <span>微信支付</span>
            <img
              class="pan-thumb-pay-text-btn-img"
              src="@/assets/purchase/pay-icon.png"
            />
          </div>
        </div>
        <div class="pan-thumb-pay-code-box">
          <div class="pan-thumb-pay-code-text">
            <img
              class="pay-code-text-img"
              src="@/assets/purchase/pay.png"
              alt=""
            />
            <div class="pay-code-text-right">
              <div class="pay-code-text-right-title">微信支付</div>
              <div class="pay-code-text-right-value">使用微信扫码支付</div>
            </div>
          </div>
          <div class="pan-thumb-pay-code">
            <img
              :class="['pan-thumb-pay-code-img', { expired: isExpired }]"
              :src="orderInfo.codeUrl"
              alt=""
            />
            <div v-if="!isExpired">打开手机端微信</div>
            <div v-if="!isExpired">扫一扫继续付款</div>
            <div v-if="isExpired" style="margin-top: 11px">
              二维码已失效，请重新获取
            </div>
            <div
              v-if="isExpired"
              style="color: #4076f2; cursor: pointer; margin-top: 5px"
              @click="handleCreateOrder"
            >
              点击请重新获取二维码
            </div>
          </div>
          <div class="pan-thumb-pay-tip">
            请您在<span style="color: #ff0909">120</span
            >s内完成支付，否则二维码将失效
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Purchase",
  props: {},
  data() {
    return {
      dialogTableVisible: false,
      loading: false,
      isOrder: false,
      radio: "",
      value: "",
      enterpriseId: "",
      radioButton: [],
      payInfo: {},
      options: [],
      orderInfo: {},
      isExpired: false,
      timer: null,
    };
  },
  methods: {
    handleClose() {
      clearInterval(this.timer);
    },
    handleEnterpriseChange(item) {
      clearInterval(this.timer);
      this.isOrder = false;
      this.payInfo = this.options.find((i) => i.value === item);
    },
    handleChange(item) {
      clearInterval(this.timer);
      this.isOrder = false;
      this.payInfo = item;
      if (item.value === "00000000-0000-0000-0000-000000000000") {
        this.value = this.options[0].value;
        this.payInfo = this.options[0];
      }
    },
    async handleCreateOrder() {
      this.loading = true;
      const { data } = await this.$api.order.CreateOrder({
        loginEnterpriseId: this.enterpriseId,
        enterpriseId: this.payInfo.value,
        projectId: this.payInfo.projectId,
      });
      this.loading = false;
      this.orderInfo = data;
      this.isExpired = false;
      this.isOrder = true;
      clearInterval(this.timer);
      setTimeout(() => {
        this.isExpired = true;
        clearInterval(this.timer);
      }, 120000);
      this.searchOrderStatus();
    },
    async searchOrderStatus() {
      this.timer = setInterval(async () => {
        const { data } = await this.$api.order.WeChatOrder({
          uniqueOrderNumber: this.orderInfo.uniqueOrderNumber,
        });
        if (data) {
          clearInterval(this.timer);
          this.$message.success("支付成功");
          this.dialogTableVisible = false;
          this.$emit("successPay");
        }
      }, 2000);
    },
    async show(enterpriseId) {
      this.enterpriseId = enterpriseId;
      this.dialogTableVisible = true;
      this.isOrder = false;
      this.loading = true;
      const { data } = await this.$api.order.BeforeCreateOrder({
        loginEnterpriseId: this.enterpriseId,
      });
      this.loading = false;
      this.radioButton = data.radioButton;
      this.radio = data.radioButton[0].value;
      this.payInfo = data.radioButton[0];
      this.options = data.enterpriseStoreList;
      if (data.radioButton.length === 1) {
        this.handleCreateOrder();
      }
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f6f8ff !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>
